import(/* webpackMode: "eager" */ "/app/src/app/[lang]/auth/login/page.tsx");
